module.exports = __webpack_public_path__ + "img/zikoo_qr_image.a7943e4f.jpg";